<template>
  <div>
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>用户金币</span>
      </div>

      <el-form ref="queryForm2" :model="queryParams2" :inline="true">
        <el-form-item clearable label="选择等级" prop="level">
          <el-select v-model="queryParams2.level" clearable placeholder="请选择">
            <el-option
              v-for="item in levelData"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="开始日期" prop="startDate">
          <el-date-picker
            v-model="queryParams2.startDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery2"
          />
        </el-form-item>
        <el-form-item label="结束日期" prop="endDate">
          <el-date-picker
            v-model="queryParams2.endDate"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @keyup.enter.native="handleQuery2"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery2">查询</el-button>
          <el-button v-permisaction="['config:userStatData:export']" icon="el-icon-download" size="mini" @click="exportData(1)">导出</el-button>
        </el-form-item>
      </el-form>

      <el-table
        :data="tableCoinData"
        border
        style="width: 100%"
      >
        <el-table-column
          prop="date"
          label="日期"
          width="100px"
        />
        <el-table-column
          prop="money1"
          label="0-10k"
        />
        <el-table-column
          prop="money2"
          label="10k-50k"
        />
        <el-table-column
          prop="money3"
          label="50k-500k"
        />
        <el-table-column
          prop="money4"
          label="500k-1M"
        />
        <el-table-column
          prop="money5"
          label="1M-5M"
        />
        <el-table-column
          prop="money6"
          label="5M-20M"
        />
        <el-table-column
          prop="money7"
          label="20M-100M"
        />
        <el-table-column
          prop="money8"
          label="100M-500M"
        />
        <el-table-column
          prop="money9"
          label="500M-1B"
        />
        <el-table-column
          prop="money10"
          label="1B-5B"
        />
        <el-table-column
          prop="money11"
          label="5B+"
        />

      </el-table>
    </el-card>
  </div>
</template>

<script>
import { exportStatData, getUserCoinStat } from '@/api/statistics/user_remain'

export default {
  name: 'UserCoin',
  data() {
    return {
      tableCoinData: [],
      coinTotal: 0,
      levelData: [],
      queryParams2: {
        pageIndex: 1,
        pageSize: 10,
        startDate: '',
        endDate: '',
        level: -1
      }
    }
  },
  created() {
    this.getUserCoinData()
  },
  methods: {
    handleQuery2(selcet = true) {
      if (this.queryParams2.startDate === '') {
        this.msgError('请选择开始日期')
        return
      }

      if (this.queryParams2.endDate === '') {
        this.msgError('请选择结束日期')
        return
      }

      if (this.queryParams2.startDate > this.queryParams2.endDate) {
        this.msgError('开始日期不能大于结束日期')
        return
      }

      if (selcet) {
        this.getUserCoinData()
      }
    },
    getUserCoinData() {
      this.levelData = [{ label: '所有等级', value: -1 }]
      getUserCoinStat(this.queryParams2).then(res => {
        if (res.code === 200) {
          this.tableCoinData = res.data.list.list
          if (this.tableCoinData) {
            res.data.list.level.forEach(item => {
              this.levelData.push({ label: '等级-' + item, value: item })
            })
          }
          this.queryParams.startDate = res.data.req.startDate
          this.queryParams.endDate = res.data.req.endDate
        } else {
          this.msgError(res.msg)
        }
      })
    },
    exportData(typ) {
      let start = ''
      let end = ''
      this.handleQuery2(false)
      start = this.queryParams2.startDate
      end = this.queryParams2.endDate

      if (start === '' || end === '') {
        return
      }
      exportStatData({ startDate: start, endDate: end, type: typ }).then(res => {
        if (res.code === 200) {
          window.open(process.env.VUE_APP_BASE_API + '/' + res.data.path)
          this.msgSuccess(res.msg)
        } else {
          this.msgError(res.msg)
        }
      })
    }

  }
}
</script>

<style scoped>

</style>
